import React from "react";
import { component_tool } from "@/tool";

const { WizRow, WizCol, WizInputNumber, WizTooltip, WizIcon } = component_tool;
import ExamCategorySelect from "../../exam/examCategorySelect/examCategorySelect";
import EditTable from "./EditTable";

export default (self, other) => {
  return [
    {
      name: "id",
      formItem: {
        type: "hidden"
      },
    },
    {
      title: "模版组名称",
      name: "title",
      formItem: {
        maxLength: 50,
        rules: [{ required: true, message: "请输入模版组名称" }]
      },
    },
    {
      title: "考试分类",
      name: "categoryTypeId",
      formItem: {
        type: "diy",
        selects: other.selects,
        diy: ExamCategorySelect,
        rules: [{ required: true, message: "请选择考试分类" }],
        onChange: (e, v) => {
          let ids = [];
          if (v) {
            ids = [v]
          }
          self.setState({ categoryTypeIds: ids })
        }
      }
    },
    {
      title: "考试时长",
      formItem: {
        type: "custom",
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return (
            <WizRow>
              <WizCol span={4}>
                {getFieldDecorator("limitMinutes", {
                  rules: [
                    { required: true, message: "请输入限制考试考试时长" },
                    { pattern: /^[0-9]{1,4}$/, message: "限制最大输入4位数" }
                  ],
                  initialValue: record.limitMinutes
                })(<WizInputNumber min={1} max={9999} />)}
              </WizCol>
              <WizCol span={1} className="limit-minutes-text">
                分钟
              </WizCol>
              <WizCol span={1}>
                <WizTooltip title={"考试用时到达后系统自动完成交卷"}>
                  <WizIcon type="question-circle-o" style={{ marginLeft: 3 }} />
                </WizTooltip>
              </WizCol>
            </WizRow>
          );
        },
      },
    },
    {
      title: "允许重复考试次数",
      formItem: {
        type: "custom",
        render: (record, form) => {
          const { getFieldDecorator } = form;
          return (
            <WizRow>
              <WizCol span={4}>
                {getFieldDecorator("count", {
                  rules: [
                    { required: true, message: "请输入允许重复考试次数" },
                    { pattern: /^[0-9]{1,4}$/, message: "限制最大输入4位数" }
                  ],
                  initialValue: record.count
                })(<WizInputNumber min={0} max={9999} />)}
              </WizCol>
              <WizCol span={1}>
                <WizTooltip title={"允许考生多次参与考试，0次则不限制次数。"}>
                  <WizIcon
                    type="question-circle-o"
                    style={{ marginLeft: 10 }}
                  />
                </WizTooltip>
              </WizCol>
            </WizRow>
          );
        },
      },
    },
    {
      title: "考试类型",
      name: "examType",
      dict: [
        {
          code: 0,
          codeName: "独立考试",
        },
        {
          code: 1,
          codeName: "课程考试",
        },
      ],
      formItem: {
        type: "select",
        rules: [{ required: true, message: "请输入考试类型" }]
      }
    },
    !other.isUpdate?
    {
      title: "关联考试模版",
      name: "examTemplateAuthInfo",
      formItem: {
        type: "diy",
        modal: true,
        links: ['examType'],
        changePopsFunction: (
          linksValues
        ) => {
          const {examType} = linksValues
          // return {apiParams:  { categoryTypeIds: other.categoryTypeIds ? other.categoryTypeIds : ['0'] ,examType:examType} ,values:['asd'] }
          return {apiParams:  { } ,values:['asd'] }
        },
        diy: EditTable,
        rules: [
          { validator: EditTable.validator },
          { required: true, message: '请添加关联考试模版' }
        ],
        // apiParams: { categoryTypeIds: other.categoryTypeIds ? other.categoryTypeIds : ['0'] } //没有选择分类不能搜索出数据
        apiParams: {  }
      },
    } :{},
    {
      title: "状态",
      name: "status",
      dict: [
        {
          code: 1,
          codeName: "有效",
        },
        {
          code: 0,
          codeName: "无效",
        },
      ],
      formItem: {
        type: "radio"
      }
    },
  ];
};
